const socialOptions = [
  {
    name: 'Facebook',
    value: 'fb',
  },
  {
    name: 'Instagram',
    value: 'ig',
  },
  {
    name: 'LinkedIn',
    value: 'li',
  },
];
export default socialOptions;
